import { type ReactNode } from 'react';
import { Button } from '@/components/ui';
import {
  type NewMemberFormState,
  type NewMemberData,
} from '../hooks/use-new-member-form';
import { PersonalSection } from './new-member-personal-section';
import { AccountSection } from './new-member-account-section';
import { PhotoSection } from './new-member-photo-section';
import { AdvancedSection } from './new-member-advanced-section';

type Props = NewMemberFormState & {
  pending: boolean;
  onSubmit: () => void;
  onCancel: () => void;
};

function FormActions(p: {
  pending: boolean;
  onSubmit: () => void;
  onCancel: () => void;
}): ReactNode {
  return (
    <div className="flex justify-end gap-sm pt-md">
      <Button variant="ghost" size="sm" onClick={p.onCancel}>
        Cancelar
      </Button>
      <Button size="md" onClick={p.onSubmit} disabled={p.pending}>
        Crear miembro
      </Button>
    </div>
  );
}

export function NewMemberForm(p: Props): ReactNode {
  const rowProps = {
    data: p.data,
    onChange: (d: NewMemberData) => p.setData(d),
    errors: p.fieldErrors,
  };
  return (
    <div className="space-y-md">
      <PersonalSection {...rowProps} />
      <AccountSection {...rowProps} />
      <PhotoSection photo={p.photo} onPick={p.setPhoto} />
      <AdvancedSection value={p.forcedStatus} onChange={p.setForcedStatus} />
      {p.error && <p className="text-xs text-error">{p.error}</p>}
      <FormActions
        pending={p.pending}
        onSubmit={p.onSubmit}
        onCancel={p.onCancel}
      />
    </div>
  );
}
